import React, { Fragment, useState, useEffect } from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Hidden, IconButton, AppBar, Box, Tooltip } from '@material-ui/core';

import { connect } from 'react-redux';

import { setSidebarToggleMobile } from '../../reducers/ThemeOptions';
import projectLogo from '../../assets/images/escolastia/logo-small.png';

import HeaderLogo from '../../layout-components/HeaderLogo';
import HeaderUserbox from '../../layout-components/HeaderUserbox';

import { useCuenta } from 'components/CuentaProvider';
import { useApi } from 'api';
import { consultarCliente } from 'api/Cliente';

import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';

const Header = props => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };
  const { headerFixed, sidebarToggleMobile, setSidebarToggleMobile } = props;

  const { cuenta } = useCuenta();
  const [clienteNombre, setClienteNombre] = useState('');
  const [{ data: clienteData }, clienteApi] = useApi();

  // El nombre del cliente puede venir en la cuenta; si no, se consulta.
  useEffect(() => {
    if (cuenta && cuenta.cliente) {
      if (cuenta.cliente.nombre) {
        setClienteNombre(cuenta.cliente.nombre);
      } else if (cuenta.cliente.id) {
        clienteApi(consultarCliente(cuenta.cliente.id));
      }
    } else {
      setClienteNombre('');
    }
  }, [cuenta]);

  useEffect(() => {
    if (clienteData && clienteData.nombre) {
      setClienteNombre(clienteData.nombre);
    }
  }, [clienteData]);

  return (
    <Fragment>
      <AppBar
        color="secondary"
        className={clsx('app-header', {
          'app-header-collapsed-sidebar': props.isCollapsedLayout
        })}
        position={headerFixed ? 'fixed' : 'absolute'}
        elevation={3}>
        {!props.isCollapsedLayout && <HeaderLogo />}
        <Box className="app-header-toolbar">
          <Hidden smUp>
            <Box
              className="app-logo-wrapper"
              title="ESCOLASTIA - Administrador">
              <Link to="/dashboard" className="app-logo-link">
                <img
                  className="app-logo-img"
                  alt="ESCOLASTIA - Administrador"
                  src={projectLogo}
                />
              </Link>
            </Box>
          </Hidden>
          {clienteNombre && (
            <Box className="app-header-client d-none d-sm-flex align-items-center">
              <span className="app-header-client-name">{clienteNombre}</span>
            </Box>
          )}
          <Box className="d-flex align-items-center ml-auto">
            <HeaderUserbox />
            <Box className="toggle-sidebar-btn-mobile">
              <Tooltip title="Toggle Sidebar" placement="right">
                <IconButton
                  color="inherit"
                  onClick={toggleSidebarMobile}
                  size="medium">
                  {sidebarToggleMobile ? (
                    <MenuOpenRoundedIcon />
                  ) : (
                    <MenuRoundedIcon />
                  )}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </AppBar>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
